import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import virtualClassroomStudentRoutes from 'modules/virtualClassrooms/common/routing/studentRoutes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const PresenterScheduleDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "VirtualClassroomStudentPresenterScheduleDetails" */ 'modules/virtualClassrooms/student/PresenterScheduleDetails/pages/PresenterScheduleDetails'
    )
)

const PresenterScheduleDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
    <Switch>
      <Route exact path={`${routes.root}/:scheduleId`} component={PresenterScheduleDetails} />
      <Redirect path='*' to={virtualClassroomStudentRoutes.root} />
    </Switch>
  </Suspense>
)

export default PresenterScheduleDetailsRouting
